export default __webpack_public_path__ + "static/media/203.a500e63b.gif";